<template>
  <div>
    <div class="bg-secondary-700">
      <div
        class="container d-flex justify-content-between align-items-center pb-2 pt-4 pb-md-4 pt-md-6"
      >
        <div>
          <h1 class="intro-name text-white mb-0">{{ meta.name }}</h1>
          <p class="intro-subtext text-opacity-muted text-white mb-0">{{ subtext }}</p>
        </div>
        <div class="pl-2 pl-lg-4">
          <button
            v-open-modal="'lunchCheckIn'"
            class="btn btn-secondary-subtle btn-sm text-nowrap d-flex flex-column align-items-center"
          >
            <UserCheckIcon class="svg-16 svg-fill-current" />
            {{ t.check_in }}
          </button>
        </div>
      </div>
      <div v-if="menus.length > 1" class="menu-wrapper w-100 pb-1 pb-md-4 d-flex container">
        <button
          v-for="(menu, index) in menus"
          :class="{ 'menu-active': activeIndex == index }"
          :key="index"
          @click="activeIndex = index"
          class="menu mr-1"
        >
          <div class="font-weight-bold">{{ menu.title }}</div>
          <div class="text-opacity-muted text-sm">{{ menu.short_description }}</div>
        </button>
      </div>
    </div>
    <LunchMenuList v-if="menus.length > 0" :menu="activeMenu" :t="t" />
    <div v-else class="container">
      <div class="py-3 d-flex flex-column">
        <Alert :title="t.check_in_title">
          <button
            v-open-modal="'lunchCheckIn'"
            class="btn btn-secondary-subtle btn-sm text-nowrap d-flex flex-column align-items-center"
          >
            {{ t.check_in_text }}
          </button>
        </Alert>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "./Alert";
import LunchMenuList from "./LunchMenuList";
import UserCheckIcon from "../../icons/atalanda/user-check.svg";

export default {
  name: "LunchMenuView",
  components: {
    Alert,
    LunchMenuList,
    UserCheckIcon,
  },
  props: {
    menus: {
      type: Array,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      open: false,
    };
  },
  computed: {
    activeMenu() {
      return this.menus[this.activeIndex];
    },
    subtext() {
      return `in ${this.meta.city}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.menu-wrapper {
  overflow-x: auto;

  &::after {
    content: "";
    flex-shrink: 0;
    width: $spacer / 2;
  }
}

.menu {
  border-radius: $border-radius;
  padding: $spacer / 4;
  text-align: left;
  border: $width-border-thick solid $white;
  color: $white;
  background: transparent;
  min-width: 130px;

  &:focus {
    outline: none;
    border-color: $gray-300;
  }
}

.menu-active {
  background: $white;
  color: $gray-900;
}

.intro-name {
  font-size: $h6-font-size;

  @media (min-width: $screen-sm-min) {
    font-size: $h2-font-size;
  }
}
</style>
